import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  InvestorStatementBatch,
  InvestorStatementItem,
} from '../../../models/admin/InvestorStatement';
import StatementReviewList from './StatementReviewList';

type ToastFn = (message: string, type: 'error' | 'warning' | 'info' | 'success') => void;

interface StatementBatchStatusProps {
  batch: InvestorStatementBatch;
  onItemsChange: (items: InvestorStatementItem[]) => void;
  onShowToast: ToastFn;
}

/** Batch status line + review list (once COMPLETED) or failure message, for StatementsSection. */
const StatementBatchStatus: React.FC<StatementBatchStatusProps> = ({
  batch,
  onItemsChange,
  onShowToast,
}) => {
  const isRunning = batch.status !== 'COMPLETED' && batch.status !== 'FAILED';

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Status: {batch.status}
        {isRunning ? '…' : ''}
      </Typography>
      {batch.status === 'COMPLETED' && (
        <StatementReviewList
          batch={batch}
          onItemsChange={onItemsChange}
          onShowToast={onShowToast}
        />
      )}
      {batch.status === 'FAILED' && (
        <Typography color="error">Statement generation failed.</Typography>
      )}
    </Box>
  );
};

export default StatementBatchStatus;
